import { demoUsersLogins } from '../../../../config';

export const getDemoUserPassword = email => {
  return demoUsersLogins[email];
};
